import { render, staticRenderFns } from "./MoleculeTheHeaderAcademyDataRequired.vue?vue&type=template&id=2f71d1b6&"
import script from "./MoleculeTheHeaderAcademyDataRequired.vue?vue&type=script&lang=js&"
export * from "./MoleculeTheHeaderAcademyDataRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports